export const PASSWORD_REQUIREMENTS = [
    { key: 'length', label: '8-20 characters', test: (value) => value.length >= 8 && value.length <= 20 },
    { key: 'lowercase', label: 'At least one letter', test: (value) => /[a-z]/.test(value) },
    { key: 'uppercase', label: 'At least one capital letter', test: (value) => /[A-Z]/.test(value) },
    { key: 'number', label: 'At least one number', test: (value) => /[0-9]/.test(value) },
    { key: 'special', label: 'At least one special character', test: (value) => /[^A-Za-z0-9]/.test(value) },
];

export const getPasswordRequirements = (password = '') =>
    PASSWORD_REQUIREMENTS.reduce((result, requirement) => {
        result[requirement.key] = requirement.test(password);
        return result;
    }, {});

export const isValidPassword = (password = '') => Object.values(getPasswordRequirements(password)).every(Boolean);
